<div class="data-catalog-window" role="dialog" aria-modal="true" aria-labelledby="dc-title" appCloseOnEscape (onEscape)="onClose()">

  <header class="window-header">
    <div class="header-left">
      <h2 id="dc-title" class="window-title">
        {{ isDataCatalog ? 'Data Catalog' : isAgent ? ('sources.agents' | transloco) : ('sources.connection' | transloco) }}
      </h2>
      <div class="header-sub">
        {{
 isDataCatalog
            ? selectedDataCatalog
            : isAgent
              ? (isAgentEditorVisible
                    ? (agent?.name?.length ? agent.name : ('sources.typesAgents.' + selectedAgentType | transloco))
                    : ('sources.agentsTable.subtitle' | transloco))
              : selectedSource.dataSourceName
        }}
        <div class="header-actions">
          <span class="dot-indicator"
                [style.background]="
                  isDataCatalog
                    ? (selectedSource.isConnectedDataCatalog ? 'var(--color-purple)' : '#ccc')
                    : (isAgent
                        ? (!agent.isStopped ? 'var(--color-purple)' : '#ccc')
                        : 'var(--color-purple)'
                      )
                ">
          </span>
        </div>
      </div>
    </div>

    <div class="header-right">
      <button class="close" (click)="onClose()" aria-label="Close"></button>
    </div>
  </header>

  <div class="window-body" tabindex="0">
    <main class="panel">
      <div class="menu">
          <button class="openmetadata" (click)="toggleDataCatalog(false)"
                  [class.toggled-datacatalog]="!isDataCatalog && !isAgent">
            {{'sources.connection' | transloco }}
          </button>

          <button class="openmetadata" (click)="toggleDataCatalog(true)"
                  title="{{'sources.settings' | transloco }} Data Catalog"
                  [class.toggled-datacatalog]="isDataCatalog">
            Data Catalog
          </button>

          <button class="openmetadata" (click)="toggleIsAgent(true)"
                  [class.toggled-datacatalog]="isAgent">
            {{'sources.agents' | transloco }}
          </button>
      </div>

      <section class="detail-information">

        <div class="form-group" *ngIf="isDataCatalog">
          <label for="driver">{{'sources.type' | transloco }}</label>

          <div class="dropdown" (click)="toggleOpen()">
            <div class="dropdown-value">
              {{ selectedDataCatalog }}
            </div>
            <div class="dropdown-list" *ngIf="open">
              <div class="dropdown-item"
                   *ngFor="let type of typesDC"
                   (click)="selectTypeDC(type); toggleOpen(); $event.stopPropagation()">
                {{ type }}
              </div>
            </div>
          </div>
        </div>

        <!-- соединение -->
        <div *ngIf="!isDataCatalog && !isAgent" class="content-selected-ds">
          <div class="grid-2">
            <div class="form-group">
              <label for="dataSourceName">{{'sources.nameSource' | transloco }}:</label>
              <input [(ngModel)]="selectedSource.dataSourceName" name="dataSourceName" type="text" appBlurOnEnter />
            </div>

            <div class="form-group" *ngIf="!isShowBI">
              <label for="driver">{{'sources.typeDB' | transloco }}</label>
              <div class="dropdown" (click)="toggleDriverDropdown()">
                <div class="dropdown-value">{{ selectedSource.dbDriver }}</div>
                <div class="dropdown-list" *ngIf="openDriverDropdown">
                  <div class="dropdown-item"
                       *ngFor="let driver of driversDWH"
                       (click)="selectDriver(driver.driverName); $event.stopPropagation()">
                    {{ driver.driverName }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="isShowBI">
              <label for="driver">{{'sources.type' | transloco }}</label>
              <div class="dropdown" (click)="toggleTypeDropdown()">
                <div class="dropdown-value">{{ selectedSource.dbType }}</div>
                <div class="dropdown-list" *ngIf="openTypeDropdown">
                  <div class="dropdown-item"
                       *ngFor="let driver of typesBI"
                       (click)="selectType(driver.driverName); $event.stopPropagation()">
                    {{ driver.driverName }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="grid-2">
            <div class="form-group">
              <label for="server">{{'sources.host' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dbServer" id="server" name="server" type="text" class="editing" appBlurOnEnter />
            </div>
            <div class="form-group">
              <label for="port">{{'sources.port' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dbPort" id="port" name="port" type="text" class="editing" appBlurOnEnter />
            </div>
          </div>

          <div class="grid-2" *ngIf="!isShowBI || selectedSource.dbType === 'Power BI' || selectedSource.dbType === 'DeltaBI'">
            <div class="form-group">
              <label for="database">{{'sources.DB' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dbDatabase" id="database" name="database" type="text" class="editing" appBlurOnEnter />
            </div>
          </div>

          <div class="grid-2" *ngIf="!selectedSource?.isAD">
            <div class="form-group">
              <label for="dbUserName">{{'sources.userName' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dbUser" id="dbUserName" name="dbUserName" type="text" class="editing" appBlurOnEnter />
            </div>

            <div class="form-group">
              <label for="dbUserPassword">{{'sources.userPassword' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dbPassword" id="dbUserPassword" name="dbUserPassword" type="password" class="editing" appBlurOnEnter />
            </div>
          </div>
          <div class="grid-2" *ngIf="selectedSource.dbDriver === 'MS SQL'">
            <div class="form-group kerberos-group">
              <button (click)="onADClick()" class="kerberos-btn"
                      [ngClass]="{ checked: selectedSource?.isAD }">
                {{ 'sources.kerberosAD' | transloco }}
              </button>
              <span class="kerberos-help-icon">
                ?
                <span class="kerberos-tooltip">{{ 'sources.ADDesc' | transloco }}</span>
              </span>
            </div>
          </div>


          <div class="form-group" *ngIf="selectedSource.dbType === 'Power BI'">
            <label for="baseUrl">{{'sources.linkToReportServer' | transloco }}</label>
            <input [(ngModel)]="selectedSource.baseUrl" id="baseUrl" name="baseUrl" type="text" class="editing" appBlurOnEnter />
          </div>

          <!-- Поля для авторизации на сайте PowerBI (всегда отображаются для сохранения всех данных) -->
          <div class="grid-2" *ngIf="selectedSource.dbType === 'Power BI'">
            <div class="form-group">
              <label for="dbUserName">{{'sources.userName' | transloco }}</label>
              <input [(ngModel)]="selectedSource.siteUser" id="dbUserName" name="dbUserName" type="text" class="editing" appBlurOnEnter />
            </div>

            <div class="form-group">
              <label for="dbUserPassword">{{'sources.userPassword' | transloco }}</label>
              <input [(ngModel)]="selectedSource.sitePassword" id="dbUserPassword" name="dbUserPassword" type="password" class="editing" appBlurOnEnter />
            </div>
          </div>

          <div class="grid-2" *ngIf="selectedSource.dbType === 'DeltaBI'">
            <div class="form-group">
              <label for="server">{{'sources.linkToReportServer' | transloco }}</label>
              <input [(ngModel)]="selectedSource.siteUrl" id="server" name="server" type="text" class="editing" appBlurOnEnter />
            </div>
            <div class="form-group">
              <label for="port">{{'sources.portToReportServer' | transloco }}</label>
              <input [(ngModel)]="selectedSource.sitePort" id="port" name="port" type="text" class="editing" appBlurOnEnter />
            </div>
          </div>

          <div class="grid-2" *ngIf="selectedSource.dbType === 'DeltaBI'">
            <div class="form-group">
              <label for="dbUserNameSite">{{'sources.loginToReportServer' | transloco }}</label>
              <input [(ngModel)]="selectedSource.siteUser" id="dbUserNameSite" type="text" class="editing" appBlurOnEnter />
            </div>

            <div class="form-group">
              <label for="dbUserPasswordSite">{{'sources.passwordToReportServer' | transloco }}</label>
              <input [(ngModel)]="selectedSource.sitePassword" id="dbUserPasswordSite" type="password" class="editing" appBlurOnEnter />
            </div>
          </div>
        </div>

        <!-- Дата каталог -->
        <div *ngIf="isDataCatalog" class="content-selected-ds dataCatalog-settings">
          <div class="grid-2">
            <div class="form-group">
              <label for="server">{{'sources.host' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dataCatalogHost" id="server" name="server" type="text" appBlurOnEnter />
            </div>

            <div class="form-group">
              <label for="port">{{'sources.port' | transloco }}</label>
              <input [(ngModel)]="selectedSource.dataCatalogPort" id="port" name="port" type="text" appBlurOnEnter />
            </div>
          </div>

          <div class="form-group">
            <label for="dbService" title="{{'sources.descServiceDC' | transloco }}">{{'sources.serviceDC' | transloco }}</label>
            <input [(ngModel)]="selectedSource.dataCatalogService" id="dbService" name="dbService" type="text" appBlurOnEnter />
          </div>

          <div *ngIf="selectedDataCatalog === 'OpenMetadata'" class="grid-2">
            <div class="form-group">
              <label for="dbUserName">{{'sources.userName' | transloco }}</label>
              <input [(ngModel)]="selectedSource.openMetadataUsername" id="dbUserName" name="dbUserName" type="text" appBlurOnEnter />
            </div>

            <div class="form-group">
              <label for="dbUserPassword">{{'sources.userPassword' | transloco }}</label>
              <input [(ngModel)]="selectedSource.openMetadataPassword" id="dbUserPassword" name="dbUserPassword" type="password" appBlurOnEnter />
            </div>
          </div>

          <div *ngIf="selectedDataCatalog === 'DataHub'" class="form-group">
            <label for="dbToken">{{'sources.token' | transloco }}</label>
            <input [(ngModel)]="selectedSource.dataHubToken" id="dbToken" name="dbToken" type="text" appBlurOnEnter />
          </div>
        </div>

        <!-- Оркестрация -->
        <div *ngIf="isAgent" class="content-selected-ds dataCatalog-settings agents-layout">
          <section class="agents-table-section">
            <div class="agents-table-header">
              <div>
                <p class="agents-table-subtitle">{{ 'sources.agents' | transloco }}</p>
                <h3 class="agents-table-title">{{ 'sources.agentsTable.title' | transloco }}</h3>
              </div>
              <div class="add-agent-menu" [class.open]="isAddAgentMenuOpen">
                <button type="button"
                        class="table-action-btn"
                        (click)="toggleAddAgentMenu($event)">
                  {{ 'sources.addAgent' | transloco }}
                </button>
                <div class="dropdown-list" *ngIf="isAddAgentMenuOpen">
                  <button type="button"
                          class="dropdown-item"
                          *ngFor="let type of typesAgent"
                          (click)="startNewAgent(type, $event)">
                    {{ 'sources.typesAgents.' + type | transloco }}
                  </button>
                </div>
              </div>
            </div>

            <div class="agents-table-wrapper">
              <table *ngIf="agentsTable.length; else agentsTableState" class="agents-table">
              <thead>
                <tr>
                  <th>{{ 'sources.agentsTable.columns.agent' | transloco }}</th>
                  <th>{{ 'sources.agentsTable.columns.schedule' | transloco }}</th>
                  <th>{{ 'sources.agentsTable.columns.stats' | transloco }}</th>
                  <th>{{ 'sources.agentsTable.columns.status' | transloco }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of agentsTable; trackBy: trackAgentRowByType"
                    [class.selected-row]="isAgentEditorVisible && selectedAgentType === row.type && (!selectedAgentId || selectedAgentId === row.agentId)">

                  <!-- Оркестратор: имя + тип + статус запуска + кнопка -->
                  <td>
                    <div class="agent-name-cell">
                      <span class="agent-name-primary">{{ row.displayName }}</span>
                      <span class="agent-name-secondary">{{ 'sources.typesAgents.' + row.type | transloco }}</span>
                      <div class="agent-actions-row">
                        <span class="status-pill dag compact"
                              [ngClass]="{
                                'status-loading': row.isDagLoading,
                                'status-running': row.isDagRunning,
                                'status-stopped': row.isDagRunning === false
                              }">
                          <ng-container *ngIf="row.isDagLoading">{{ 'sources.agentsTable.dagStatus.loading' | transloco }}</ng-container>
                          <ng-container *ngIf="!row.isDagLoading">
                            <ng-container *ngIf="row.isDagRunning === true">{{ 'sources.agentsTable.dagStatus.running' | transloco }}</ng-container>
                            <ng-container *ngIf="row.isDagRunning === false">{{ 'sources.agentsTable.dagStatus.idle' | transloco }}</ng-container>
                            <ng-container *ngIf="row.isDagRunning === undefined">{{ 'sources.agentsTable.dagStatus.unknown' | transloco }}</ng-container>
                          </ng-container>
                        </span>
                        <button type="button"
                                class="table-action-btn compact"
                                [disabled]="!row.dagId || row.isDagLoading || row.statusKey === 'deleted' || row.isStopped"
                                [title]="row.isStopped ? ('sources.agentsTable.stoppedHint' | transloco) : ''"
                                (click)="runDagFromTable(row, $event)">
                          ▶
                        </button>
                      </div>
                    </div>
                  </td>

                  <!-- Расписание -->
                  <td>
                    <button type="button"
                            class="schedule-cell"
                            (click)="handleScheduleCellClick(row, $event)">
                      <span>{{ row.scheduleText }}</span>
                      <span class="cell-hint">{{ 'sources.agentsTable.editHint' | transloco }}</span>
                    </button>
                  </td>

                  <!-- Логи: компактная горизонтальная строка -->
                  <td>
                    <div class="dag-stats" *ngIf="row.dagStats && !row.isDagStatsLoading; else dagStatsState">
                      <span class="dag-stats__item success" [attr.title]="('sources.agentsTable.dagStats.success' | transloco)">
                        <span class="value">{{ row.dagStats?.success ?? 0 }}</span>
                        <span class="label-text">{{ 'sources.agentsTable.dagStats.successShort' | transloco }}</span>
                        <span class="label-icon">✓</span>
                      </span>
                      <span class="dag-stats__item failed" [attr.title]="('sources.agentsTable.dagStats.failed' | transloco)">
                        <span class="value">{{ row.dagStats?.failed ?? 0 }}</span>
                        <span class="label-text">{{ 'sources.agentsTable.dagStats.failedShort' | transloco }}</span>
                        <span class="label-icon">✗</span>
                      </span>
                      <span class="dag-stats__item running" [attr.title]="('sources.agentsTable.dagStats.running' | transloco)">
                        <span class="value">{{ row.dagStats?.running ?? 0 }}</span>
                        <span class="label-text">{{ 'sources.agentsTable.dagStats.runningShort' | transloco }}</span>
                        <span class="label-icon">▶</span>
                      </span>
                      <span class="dag-stats__item queued" [attr.title]="('sources.agentsTable.dagStats.queued' | transloco)">
                        <span class="value">{{ row.dagStats?.queued ?? 0 }}</span>
                        <span class="label-text">{{ 'sources.agentsTable.dagStats.queuedShort' | transloco }}</span>
                        <span class="label-icon">◷</span>
                      </span>
                    </div>
                    <ng-template #dagStatsState>
                      <span class="dag-stats__placeholder">
                        {{ row.isDagStatsLoading ? '…' : '—' }}
                      </span>
                    </ng-template>
                  </td>

                  <!-- Статус -->
                  <td>
                    <span class="status-pill" [ngClass]="'status-' + row.statusKey">
                      {{ 'sources.agentsTable.status.' + row.statusKey | transloco }}
                    </span>
                  </td>
                </tr>
              </tbody>
              </table>
            </div>
            <ng-template #agentsTableState>
              <div class="agents-table__empty">
                {{ isAgentsTableLoading ? ('sources.agentsTable.loading' | transloco) : ('sources.agentsTable.noData' | transloco) }}
              </div>
            </ng-template>

            <div class="agents-table__hint" *ngIf="agentsTable.length">
              {{ 'sources.agentsTable.selectHint' | transloco }}
            </div>
          </section>
        </div>

        <div class="agent-editor-modal" *ngIf="isAgent && isAgentEditorVisible">
          <div class="agent-editor-modal__backdrop" (click)="closeAgentEditor()"></div>
          <div class="agent-editor-modal__card" role="dialog" aria-modal="true">
            <header class="agent-editor-modal__header">
              <div>
                <p class="agent-editor-modal__eyebrow">{{ 'sources.agentsTable.settingsTitle' | transloco }}</p>
                <h3>{{ agent?.name?.length ? agent.name : ('sources.typesAgents.' + selectedAgentType | transloco) }}</h3>
              </div>
              <button type="button"
                      class="agent-editor-close"
                      (click)="closeAgentEditor()">
              </button>
            </header>

            <section class="agent-editor-section">
              <div *ngIf="isAgent" class="schedule-editor-content">
                <div class="form-group agent-name-group">
                  <label for="agentNameInput">{{ 'sources.agentName' | transloco }}</label>
                  <input id="agentNameInput"
                         type="text"
                         [(ngModel)]="agent.name"
                         placeholder="{{ 'sources.agentNamePlaceholder' | transloco }}"
                         class="editing" />
                </div>

                <div class="schedule-section">
                  <label class="section-label">{{'sources.every' | transloco }}</label>
                  <div class="interval-row">
                    <div class="chips interval-chips">
                      <button type="button"
                              class="chip"
                              *ngFor="let interval of intervals"
                              (click)="selectIntervalType(interval)"
                              [class.selected]="selectedScheduleType === interval && !isNoSchedule">
                        {{'sources.intervals.' + interval | transloco }}
                      </button>
                    </div>
                    <label class="manual-start-option">
                      <input *ngIf="isAgent" type="radio" (change)="clickNoSchedule()" [checked]="isNoSchedule">
                      <span>{{'sources.manualStart' | transloco }}</span>
                    </label>
                  </div>
                </div>

                <ng-container *ngIf="!isNoSchedule">
                  <div *ngIf="selectedScheduleType != 'user'" class="time-inputs-row">
                    <div *ngIf="selectedScheduleType != 'hour'" class="time-input-group">
                      <label for="hourInput">{{ 'sources.intervals.hour' | transloco }}</label>
                      <input id="hourInput"
                             name="hourInput"
                             type="text"
                             [(ngModel)]="agent.hour"
                             (keypress)="allowOnlyDigits($event)"
                             (input)="maskHour($event)"
                             placeholder="00"
                             appBlurOnEnter />
                    </div>

                    <div class="time-input-group">
                      <label for="minuteInput">{{ 'sources.intervals.minute' | transloco }}</label>
                      <input id="minuteInput"
                             name="minuteInput"
                             [(ngModel)]="agent.minute"
                             maxlength="2"
                             (keypress)="allowOnlyDigits($event)"
                             (input)="maskMinute($event)"
                             placeholder="00"
                             appBlurOnEnter />
                    </div>
                  </div>

                  <div *ngIf="selectedScheduleType === 'week'" class="weekdays-section">
                    <label class="section-label">{{'sources.intervals.day' | transloco }}</label>
                    <div class="chips weekday-chips">
                      <button *ngFor="let day of days" type="button"
                              class="chip"
                              (click)="agent.weekdayName = day"
                              [class.selected]="agent.weekdayName === day">
                        {{'sources.days.' + day | transloco }}
                      </button>
                    </div>
                  </div>

                  <div *ngIf="selectedScheduleType === 'month'" class="monthdays-section">
                    <label class="section-label">{{'sources.intervals.day' | transloco }}</label>
                    <div class="chips monthday-chips">
                      <button *ngFor="let date of dates" type="button"
                              class="chip"
                              (click)="agent.monthday = date"
                              [class.selected]="agent.monthday === date">
                        {{ date }}
                      </button>
                    </div>
                  </div>

                  <div class="schedule-text">
                    <ng-container [ngSwitch]="selectedScheduleType">
                      <span *ngSwitchCase="'hour'">
                        {{ 'sources.launchText.every' | transloco }} {{ 'sources.launchText.hour' | transloco }}
                        {{ 'sources.launchText.at' | transloco }}
                        {{ agent.minute < 10 ? ('0' + agent.minute) : agent.minute }} {{ 'sources.launchText.minutes' | transloco }}
                      </span>

                      <span *ngSwitchCase="'day'">
                        {{ 'sources.launchText.every' | transloco }} {{ 'sources.launchText.day' | transloco }}
                        {{ 'sources.launchText.at' | transloco }} {{ agent.hour < 10 ? ('0' + agent.hour) : agent.hour }}:{{ agent.minute < 10 ? ('0' + agent.minute) : agent.minute }}
                      </span>

                      <span *ngSwitchCase="'week'">
                        {{ 'sources.launchText.everyWeekDay.' + agent.weekdayName | transloco }}
                        {{ 'sources.launchText.at' | transloco }} {{ agent.hour < 10 ? ('0' + agent.hour) : agent.hour }}:{{ agent.minute < 10 ? ('0' + agent.minute) : agent.minute }}
                      </span>

                      <span *ngSwitchCase="'month'">
                        {{ 'sources.launchText.every' | transloco }} {{ 'sources.launchText.month' | transloco }}
                        {{ agent.monthday }} {{ 'sources.launchText.monthDay' | transloco }}
                        {{ 'sources.launchText.at' | transloco }} {{ agent.hour < 10 ? ('0' + agent.hour) : agent.hour }}:{{ agent.minute < 10 ? ('0' + agent.minute) : agent.minute }}
                      </span>

                      <span *ngSwitchCase="'user'">
                        {{ 'sources.launchText.userDatePrefix' | transloco }} {{ agent.userDateTimeStr || '--' }}
                      </span>
                    </ng-container>
                  </div>

                  <div class="datetime-section">
                    <label for="userDateTime">{{ 'sources.dateLaunch' | transloco }}:</label>
                    <input id="userDateTime"
                           class="datetime-input"
                           mwlFlatpickr
                           [(ngModel)]="agent.userDateTimeStr"
                           [enableTime]="true"
                           [time24hr]="true"
                           dateFormat="Y-m-d H:i"
                           [altInput]="true"
                           altFormat="d.m.Y H:i"
                           [allowInput]="true"
                           (flatpickrChange)="onFlatpickrChange($event)"
                           placeholder="{{ 'sources.selectDateTime' | transloco }}">
                  </div>

                </ng-container>

              </div>
            </section>

            <footer class="agent-editor-footer">
              <div class="footer-left" *ngIf="!this.agent.isDeleted && !isNewAgent">
                <button class="button-left save-button danger" (click)="deleteAgent()">
                  {{ 'sources.delete' | transloco }}
                </button>
              </div>
              <div class="footer-right">
                <button type="button" class="save-button ghost" (click)="closeAgentEditor()">
                  {{ 'sources.cancel' | transloco }}
                </button>
                <button type="button" class="save-button" (click)="saveAgentSettings(true)">
                  {{ 'sources.apply' | transloco }}
                </button>
              </div>
            </footer>
          </div>
        </div>

      </section>
    </main>
  </div>

  <footer>
    <div class="window-footer" *ngIf="!isAgent">
      <div class="footer-left" *ngIf="!isDataCatalog">
        <button class="button-left save-button ghost" (click)="checkConnection()">
          {{ 'sources.checkConnection' | transloco }}
        </button>
      </div>
      <div class="footer-right">
        <button class="save-button" (click)="saveSource(false)">{{ 'sources.apply' | transloco }}</button>
        <button class="save-button" (click)="saveSource(true)">{{ 'sources.applyAndClose' | transloco }}</button>
      </div>
    </div>

  </footer>
</div>
